import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper";
import ShipPainting from "src/games/ShipPainting/Main";
import { message } from 'antd';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(XraySliderGame)'
interface ShipPaintingProps extends RouteComponentProps<{}> {
    onComplete?: () => void;
}

interface ShipPaintingState {
}

class ShipPaintingGame extends React.Component<ShipPaintingProps, ShipPaintingState> {
    constructor(props: ShipPaintingProps) {
        super(props);
        bindAllOfThis(this, ShipPaintingGame.prototype);

        // You are allowed to set defaults here, based on your state object above
        this.state = {
        };
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <ShipPainting onComplete={this.completeGame}/>
        </div>;
    }
}

export default ShipPaintingGame;



// WEBPACK FOOTER //
// ./src/pages/game/ShipPaintingGame.tsx